<!-- 生产数量 -->
<template>
  <BaseFormItem
    class="number"
    :label="fields.label"
    :labelTips="fields.labelTips"
    isShowRequiredIcon
    :fillTips="fillTips"
    :isError="isError"
    :isErrorBlink="isErrorBlink"
  >
    <template v-if="isShowNumberType">
      <!-- 生产数量类型 -->
      <BaseRadioGroup 
        v-model="val.number_type" 
        @change="val => handleChange(val, 'number_type')"
      >
        <el-radio-button :label="1">
          {{ pcbNumber }}片全贴
        </el-radio-button>
        <el-radio-button :label="0">
          其他数量
        </el-radio-button>
      </BaseRadioGroup>
      <template v-if="val.number_type === 0">
        <i class="el-icon-minus number__separator" />
        <!-- 其他数量 -->
        <BaseInput 
          v-model="val.number" 
          width="170px"
          placeholder="请输入"
          @input="val => handleEmit('number')"
          @change="handleNumberChange"
        >
          <div slot="prepend">
            输入数量
          </div>
        </BaseInput>
        <div slot="other" class="number_tips">
          <template v-if="pcbNumber > val.number">
            剩余<span>{{ pcbNumber - val.number }}</span>片PCB未贴片，随货退回
          </template>
          <template v-if="pcbNumber < val.number">
            PCB还差<span>{{ val.number - pcbNumber }}</span>片
          </template>
        </div>
      </template>
    </template>

    <!-- 生产数量 -->
    <template v-else>
      <BaseInput
        v-model="val.number"
        width="200px"
        placeholder="生产数量"
        :max="max"
        @input="val => handleEmit('number')"
        @change="handleNumberChange"
      ></BaseInput>
      <div slot="other">
        {{ fields.unit }}
      </div>
    </template>
  </BaseFormItem>
</template>

<script>
import { getSMTFields } from '@@/utils/getFields'
import { isPositiveInteger } from '@@/utils/utils'

export default {
  props: {
    // 生产数量
    number: {
      type: [Number, String],
      default: 1
    },
    // 生产数量类型: 1-PCB数量全贴 0-其他数量
    number_type: {
      type: Number,
      default: 1
    },
    max: {
      type: [Number, String],
      default: ''
    },
    // 是否显示生产数量类型
    isShowNumberType: {
      type: Boolean,
      default: false
    },
    // PCB数量
    pcbNumber: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      val: {
        number: this.number,
        number_type: this.number_type
      },
      isError: false, // 是否显示错误提示样式
      isErrorBlink: false, // 是否显示错误提示样式且闪两下
    }
  },
  computed: {
    fields() {
      return getSMTFields('number')
    },
    // 是否显示未填写样式
    fillTips() {
      const { val, isShowNumberType} = this
      return !isShowNumberType && !val.number ? '请输入' : ''
    }
  },
  watch: {
    number(newVal) {
      this.val.number = newVal
    },
    number_type(newVal) {
      this.val.number_type = newVal
    },
  },
  methods: {
    handleEmit(key) {
      this.$emit(`update:${key}`, this.val[key])
      this.isShowError(false)
    },
    handleEmitChange() {
      this.$emit('change', { ...this.val })
    },
    handleChange(val, key) {
      this.val[key] = val
      this.handleEmit(key)
      this.handleEmitChange()
    },
    handleNumberChange(val) {
      if (isPositiveInteger(val)) {
        // 最小值 1
        val = Math.max(val, 1)
        // 最大值 1000000
        val = Math.min(val, 1000000)
        // 四舍五入
        val = Math.round(val)
        this.handleChange(val, 'number')
        this.isShowError(false)
      } else {
        this.handleChange('', 'number')
      }
    },
    // 是否显示错误提示样式
    isShowError(isShow, isBlink = false) {
      this.isError = isShow
      this.isErrorBlink = isBlink
    }
  }
}
</script>

<style lang="scss" scoped>
.number {
  .number__separator {
    margin: 0 5px;
  }
  .number_tips {
    >span {
      color: $--color-primary;
    }
  }
}
</style>